import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'

import { WidgetFooter } from '../Widget/WidgetFooter'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const textColors = {
  active: '#1265a9',
  inactive: '#0e283fd9',
}

const getStyles = (theme: Theme) => ({
  footer: {
    paddingBottom: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },

  headerText: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontFamily: 'Source Sans Pro Semibold',
  },

  total: {
    color: theme.palette.primary.main,
    fontSize: 28,
    fontFamily: 'Source Sans Pro Semibold',
    marginRight: theme.spacing(0.8),
  },
})

export type Props = {
  callToActionFunction: () => void
  callToActionText: string
  callToActionAllowed: boolean
  children?: JSX.Element
  className?: string
  description: JSX.Element
  headerText: string
  secondaryCallToActionFunction?: () => void
  secondaryCallToActionText?: string
  secondaryCallToActionAllowed?: boolean
  total: string | number
  isClickable?: boolean
  testIdPrefix?: string
}

export const TotalAndDescription: FC<Props> = (props) => {
  const styles = getStyles(useTheme())
  const { isClickable = true, testIdPrefix = 'total-and-description' } = props
  return (
    <>
      <Box
        data-test-id={`${testIdPrefix}-header`}
        onClick={isClickable ? props.callToActionFunction : undefined}
        sx={{ cursor: isClickable ? 'pointer' : 'default' }}
        display="flex"
        alignItems="center"
      >
        <Typography
          sx={{
            ...styles.total,
            color: isClickable ? textColors.active : textColors.inactive,
          }}
          display="inline"
        >
          {props.total}
        </Typography>
        <Typography
          sx={{
            ...styles.headerText,
            color: isClickable ? textColors.active : textColors.inactive,
          }}
          display="inline"
        >
          {props.headerText}
        </Typography>
      </Box>
      <Typography variant="body1">{props.description}</Typography>
      <WidgetFooter
        testIdPrefix={testIdPrefix}
        sx={styles.footer}
        callToActionFunction={props.callToActionFunction}
        callToActionText={props.callToActionText}
        callToActionAllowed={props.callToActionAllowed}
        secondaryCallToActionFunction={props.secondaryCallToActionFunction}
        secondaryCallToActionText={props.secondaryCallToActionText}
        secondaryCallToActionAllowed={props.secondaryCallToActionAllowed}
      />
    </>
  )
}

TotalAndDescription.displayName = 'TotalAndDescription'
